"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgPerson03Positive = function SvgPerson03Positive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M7.821 70.948a2.118 2.118 0 01-2.117-2.117c0-8.697 4.538-15.53 10.327-15.53h4.32a2.118 2.118 0 110 4.235h-4.32c-3.586 0-6.092 5.944-6.092 11.295 0 1.17-.948 2.117-2.118 2.117z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M50.386 114.544c-14.344 0-27.36-12.064-32.767-30.205H16.03c-5.789 0-10.327-6.819-10.327-15.53a2.118 2.118 0 114.235 0c0 5.337 2.506 11.295 6.092 11.295h3.155a2.118 2.118 0 012.075 1.567c4.603 17.138 16.306 28.651 29.125 28.651a22.327 22.327 0 003.148-.218 2.118 2.118 0 11.6 4.185 25.668 25.668 0 01-3.748.255z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M2.118 142.13a2.118 2.118 0 01-1.412-3.7c4.433-3.945 18.748-11.364 27.607-13.92v-19.764a2.118 2.118 0 014.235 0v21.388c0 .984-.679 1.838-1.637 2.061-8.323 1.963-23.584 10.01-27.382 13.398a2.118 2.118 0 01-1.411.536z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M17.16 41.125a2.118 2.118 0 01-2.118-2.118v-7.059C15.042 11.21 30.854 0 45.727 0h9.459c16.158 0 28.376 11.125 30.416 27.678a2.133 2.133 0 01-4.235.515C79.631 13.863 69.1 4.235 55.186 4.235h-9.459c-17.181 0-26.45 14.294-26.45 27.741v7.06a2.118 2.118 0 01-2.117 2.089zM67.144 108.219a2.118 2.118 0 01-1.342-3.755 33.522 33.522 0 003.12-2.923c4.807-5.09 8.47-12 10.589-19.885a2.118 2.118 0 012.075-1.567h3.162c3.586 0 6.092-5.943 6.092-11.294 0-5.35-2.506-11.294-6.092-11.294h-4.32a2.118 2.118 0 110-4.235h4.32c5.788 0 10.327 6.819 10.327 15.53 0 8.71-4.539 15.529-10.327 15.529h-1.595c-2.358 7.927-6.19 14.823-11.146 20.11a38.605 38.605 0 01-3.53 3.297 2.118 2.118 0 01-1.333.487z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M98.76 142.13c-.52 0-1.023-.19-1.412-.537-3.797-3.388-19.059-11.435-27.38-13.412a2.118 2.118 0 01-1.639-2.061v-21.96a2.118 2.118 0 014.236 0v20.35c8.851 2.556 23.174 9.975 27.6 13.92a2.118 2.118 0 01-1.412 3.7h.007z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M20.379 67.567a2.118 2.118 0 01-2.118-2.118V49.214a2.118 2.118 0 014.235 0V65.45c0 1.17-.948 2.118-2.117 2.118zM80.4 67.567a2.118 2.118 0 01-2.118-2.118V49.214a2.118 2.118 0 014.236 0V65.45c0 1.17-.948 2.118-2.118 2.118zM90.438 44.266a2.118 2.118 0 01-.798-.162c-10.08-4.137-24.388-6.502-39.254-6.502-14.866 0-29.061 2.35-39.092 6.452A2.118 2.118 0 119.7 40.13c10.708-4.362 25.172-6.762 40.722-6.762s30.134 2.421 40.857 6.819a2.118 2.118 0 01-.805 4.08h-.035z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M53.81 50.986a1.412 1.412 0 01-.248 0 28.814 28.814 0 01-10.927-3.734 2.118 2.118 0 012.245-3.593 24.748 24.748 0 009.176 3.106 2.121 2.121 0 11-.24 4.235l-.007-.014zM63.784 50.922a2.127 2.127 0 01-.396-4.235 7.426 7.426 0 002.47-1.038 2.118 2.118 0 012.415 3.48 11.605 11.605 0 01-4.101 1.723 2.478 2.478 0 01-.388.07z",
    fill: "#285"
  })));
};

var _default = SvgPerson03Positive;
exports["default"] = _default;